import { render, staticRenderFns } from "./ProCard2.vue?vue&type=template&id=14ca07e0&scoped=true"
import script from "./ProCard2.vue?vue&type=script&lang=js"
export * from "./ProCard2.vue?vue&type=script&lang=js"
import style0 from "./ProCard2.vue?vue&type=style&index=0&id=14ca07e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca07e0",
  null
  
)

export default component.exports